import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import chevronRightBlack from '../../../../images/chevron-right-black.svg';
import chevronRightDisabled from '../../../../images/chevron-right-disabled.svg';
import chevronLeftBlack from '../../../../images/chevron-left-black.svg';
import chevronLeftDisabled from '../../../../images/chevron-left-disabled.svg';
import Image from '../../../Core/Image';

export const Heading = styled.h2`
  margin-bottom: 40px;
  color: ${({ headingColor }) =>
    headingColor
      ? themeGet(`colors.${headingColor}`)
      : themeGet('colors.main-text')};
  text-align: ${({ contentAlignment }) =>
    contentAlignment ? `${contentAlignment}` : 'left'};

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-bottom: 36px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin-bottom: 68px;
  }
`;

export const Gallery = styled.div`
  position: relative;
  margin: 0 auto;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: flex;
    justify-content: center;
  }
`;

export const CarouselControls = styled.div`
  display: block;
  margin: 2rem auto;

  ul {
    display: flex;
    justify-content: center;
    align-items: center;

    li {
      margin: 0 1rem;
    }

    li:not(:first-child) {
      margin-top: 0;
    }
  }
`;

export const CarouselBtn = styled.button`
  width: 18px;
  height: 18px;
  background-repeat: no-repeat;
  &.previous-carousel {
    background-image: url(${chevronLeftBlack});
    &:disabled {
      background-image: url(${chevronLeftDisabled});
    }
  }
  &.next-carousel {
    background-image: url(${chevronRightBlack});
    &:disabled {
      background-image: url(${chevronRightDisabled});
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-top: 3rem;
    flex-direction: row;
  }
`;

export const CarouselImageWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const StyledImage = styled(Image)`
  max-width: 300px;
  width: 100%;
  height: 200px;
`;

export const Wrapper = styled.div`
  margin: auto;
  overflow: hidden;
`;
